module.exports = __webpack_public_path__ + "static/media/img-talent-profile-rating@3x.2dfc402d.png";